<template>
  <div class="headerBar">
    <div class="headerInnerContainer">
        <img src="https://springerhealthcare.com/wp-content/uploads/thegem-logos/logo_134d4b66f5f2b65ab331ba75e0caa571_1x.png">
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>